<template>
  <div id="app">
    <div class="wrap" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />
      <div class="payment">
        <div class="process">
          <div class="step-wrap chk-white">
            <span class="step step--n01 on" :class="{checked: !orderCheckYn}">01</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg1') }}</span>
          </div>
          <div class="step-wrap chk-white" v-if="orderType == 'F'">
            <span class="step step--n02" :class="{on: !orderCheckYn && adultCertificationYn, 'on checked': !adultCertificationYn && !orderCheckYn}">02</span>
            <span class="step-txt">{{ $t('User.AdultCertification.msg1') }}</span>
          </div>
          <div class="step-wrap chk-white" v-if="useMembership || useStamp || useCoupon">
            <span
              class="step step--n02"
              :class="{on: !adultCertificationYn && !orderCheckYn && orderSavingYn, 'on checked': !adultCertificationYn && !orderSavingYn && !orderCheckYn}"
              >{{ orderType == 'F' ? '03' : '02' }}</span
            >
            <span class="step-txt">{{ $t('User.OrderCheck.msg2') }}</span>
          </div>
          <div class="step-wrap chk-white">
            <span class="step step--n03" :class="{on: !orderSavingYn && paySelectYn}">{{
              orderType == 'F' ? (useMembership || useStamp || useCoupon ? '04' : '03') : useMembership || useStamp || useCoupon ? '03' : '02'
            }}</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg3') }}</span>
          </div>
          <div class="step-wrap chk-white" v-if="useAlarmTalk || usePager">
            <span class="step step--n04">{{
              orderType == 'F' ? (useMembership || useStamp || useCoupon ? '05' : '04') : useMembership || useStamp || useCoupon ? '04' : '03'
            }}</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg4') }}</span>
          </div>
        </div>

        <!-- 주문내역 확인 -->
        <OrderCheck @setOrder="nextOrder" :orderCheckYn="orderCheckYn" />

        <!-- 멤버쉽 -->
        <OrderSaving
          @backSaving="
            orderCheckYn = true;
            orderSavingYn = false;
          "
          @setSaving="
            orderSavingYn = false;
            paySelectYn = true;
          "
          @setMembersUseObj="setMembersUseObj"
          :orderSavingYn="orderSavingYn"
        />

        <!-- 성인인증 -->
        <AdultCertification :adultCertificationYn="adultCertificationYn" @setOrder="setOrder" />

        <!-- 결제 선택 -->
        <PaySelect @backPay="backPay" :paySelectYn="paySelectYn" :membersUseObj="membersUseObj" />

        <!-- 결제화면 버튼 영역 -->
        <BtnBottomPayment />

        <!-- 공통 alert -->
        <AlertSuccess v-if="alertSuccessYn" :message="message" :text="$t('Modal.AlertSuccess.msg1')" @setYes="alertSuccessYn = false" />
      </div>
    </div>
  </div>
</template>
<script>
import helperHeight from '@/components/common/HelperHeight.vue';
import orderCheck from '@/components/user/payment/OrderCheck.vue';
import orderSaving from '@/components/user/payment/OrderSaving.vue';
import paySelect from '@/components/user/payment/PaySelect.vue';
import btnBottomPayment from '@/components/user/payment/BtnBottomPayment.vue';
import audioHelper from '@/js/common/audioHelper.js';
import axios from 'axios';
import alertSuccess from '@/components/modal/alert/AlertSuccess.vue';
import adultCertification from '@/components/user/payment/AdultCertification.vue';
import chargeHelper from '@/js/common/chargeHelper.js';

export default {
  name: 'payment',
  methods: {},
  props: {
    contryType: String,
  },
  data() {
    return {
      message: '',
      orderCheckYn: true,
      orderSavingYn: false,
      paySelectYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      useMembership: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY41') >= 0,
      useCoupon: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY47') >= 0,
      useStamp: false,
      alertSuccessYn: false,
      useAlarmTalk: this.$store.getters.getPosConfig.posConfig.useAlarmTalk,
      usePager: this.$store.getters.getPosConfig.posConfig.usePager,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      supportPayments: this.$store.getters.getPosConfig.posConfig.supportPayments,
      adultCertificationYn: false,
      oneCallYn: false,
      membersUseObj: null,
    };
  },
  mounted() {
    this.$logInfo(`Enter Payment pages`);

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      audioHelper.playAudio('00108', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  methods: {
    //멤버쉽 담기
    setMembersUseObj(membersUseObj) {
      this.membersUseObj = membersUseObj;
    },
    // 주문내역 다음 스탭
    nextOrder() {
      if (this.orderType == 'F') {
        this.orderCheckYn = false;
        this.adultCertificationYn = true;
      } else {
        this.setOrder();
      }
    },
    //와인키오스크가 아닐 경우 상품 등록
    setOrder() {
      this.adultCertificationYn = false;
      this.orderCheckYn = false;
      if (this.useMembership || this.useStamp || this.useCoupon) {
        this.orderSavingYn = true;
      } else {
        this.orderSavingYn = false;
        this.paySelectYn = true;
      }
    },
    //결제선택 이전 화면
    backPay() {
      if (this.useMembership || this.useStamp || this.useCoupon) {
        if (this.$store.getters.getMembershipApplyYn) {
          chargeHelper.cancleMembership(this.$store.getters.getBaskets);
          this.$store.dispatch('setMembershipApplyYn', false);
          this.membersUseObj = null;
          this.orderSavingYn = false;
          this.paySelectYn = false;
          this.orderCheckYn = true;
        } else {
          this.orderSavingYn = true;
          this.paySelectYn = false;
        }
      } else {
        this.orderCheckYn = true;
        this.orderSavingYn = false;
        this.paySelectYn = false;
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  created() {},
  beforeCreate() {},
  components: {
    OrderCheck: orderCheck,
    OrderSaving: orderSaving,
    PaySelect: paySelect,
    BtnBottomPayment: btnBottomPayment,
    HelperHeight: helperHeight,
    AlertSuccess: alertSuccess,
    AdultCertification: adultCertification,
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/pages/table.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
.
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped></style>
